/** mail */
const send = () => import('../view/mailSystem/send')
const model = () => import('../view/mailSystem/model')
const statistics = () => import('../view/mailSystem/statistics')
const connect = () => import('../view/mailSystem/connect')
const blacklist = () => import('../view/mailSystem/blacklist')
const mailbox = () => import('../view/mailSystem/mailbox')

const path = '/mail'

export default [
  {
    // 邮件发送
    path: path + '/send',
    component: send,
    name: "邮件发送",
  }, {
    // 模板管理
    path: path + '/model',
    component: model,
    name: "模板管理",
  }, {
    // 单个订单发送记录
    path: path + '/statistics',
    component: statistics,
    name: "单个订单发送记录",
  }, {
    // 通讯录
    path: path + '/connect',
    component: connect,
    name: "通讯录",
  }, {
    // 发件箱管理
    path: path + '/mailbox',
    component: mailbox,
    name: "发件箱管理",
  }, {
    // 黑名单
    path: path + '/blacklist',
    component: blacklist,
    name: "黑名单",
  },
]